import React from 'react';
import { ToastContainer as ToastifyContainer } from 'react-toastify';
import 'react-toastify/ReactToastify.min.css';
import Icon from '../Icon';
const ToastContainer = () => {
  return (
    <ToastifyContainer
      position="bottom-right"
      autoClose={false}
      hideProgressBar={true}
      newestOnTop={true}
      draggable={false}
      closeOnClick={false}
      closeButton={({ ariaLabel, closeToast }) => (
        <Icon
          name="close"
          className="absolute right-2 top-2 h-4 w-4 cursor-pointer"
          aria-label={ariaLabel}
          onClick={(e) => closeToast(e as any)}
        />
      )}
    ></ToastifyContainer>
  );
};

export default ToastContainer;
